export default __webpack_public_path__ + "img/d9c3632fcdbdf13bb84661480eca2af0.png";